import Carousel from './Carousel'
const Inicio = () => {
    return(<>
        <Carousel></Carousel>
    </>)
}

export default Inicio;